export default __webpack_public_path__ + "static/media/terragon.7ba96626.svg";